import ComponentBase from "../../../public/component/component_base";

const { ccclass, property } = cc._decorator;

@ccclass
export default class PokerRecorderShortItem extends ComponentBase{

    @property(cc.Label)
    labelName: cc.Label = null

    @property(cc.Label)
    labelCount: cc.Label = null

    get config(){
        return this.m_config
    }

    protected m_config: {point: number, name: string}

    setData(data){
        this.labelCount.string = data.count
        this.labelCount.node.color = data.count > 0? cc.Color.WHITE.fromHEX('#EC5307'): cc.Color.WHITE.fromHEX('#BD9480')
    }

    setConfig(conf){
        this.m_config = conf
        this.labelName.string = this.m_config.name
    }
}